import { render, staticRenderFns } from "./ClassroomAssignmentsTab.vue?vue&type=template&id=040d0743&"
import script from "./ClassroomAssignmentsTab.vue?vue&type=script&lang=js&"
export * from "./ClassroomAssignmentsTab.vue?vue&type=script&lang=js&"
import style0 from "./ClassroomAssignmentsTab.vue?vue&type=style&index=0&id=040d0743&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports